import UnderMaintenanceImage from 'assets/images/under-maintenance.png'
import { Button } from 'avo-ui'
import { innerHTML } from 'utils/utils'

export const UnderMaintenance = ({ errorData, onReload }) => {
    return (
        <div className={'flex flex-col h-screen items-center justify-center space-y-4'}>
            <img
                src={errorData?.image_url || UnderMaintenanceImage}
                alt={'under-maintenance-image'}
                className={'w-1/2 h-1/2'}
            />
            <p className={'font-bold text-primary-100 text-lg'}>{errorData?.title || 'Under Maintenance'}</p>
            <div
                className={'text-primary-100'}
                dangerouslySetInnerHTML={innerHTML(errorData?.description || 'Will be Back Soon!')}
            />
            <Button
                className={'w-60 !bg-gradient-to-b !from-[#06308D] !to-[#3C6CD6] !border-neutral-20'}
                title={'REFRESH PAGE'}
                onClick={onReload}
            />
        </div>
    )
}
